import React from 'react';
import connect from '../../stores/parent-onboarding';
import MainHeader from '../../components/main-header';
import {assetPath} from '../../utils/web-helper';
import ParentMode from '../../../images/onboarding/parent-mode.png';
import ClassMode from '../../../images/onboarding/class-mode.png';

class SelectAccountMode extends React.Component {
  constructor(props) {
    super(props)
    this.state = {

    }
  }

  accountModeHandler = async (continueOnBoarding) => {

    if(continueOnBoarding) {
      trackAnalyticsEvent('Tapped on Create Account',
      {'From': 'Onboarding','From Page': 'Homepage'}, true);
      location.href = '/parents/register';
    }
    else {
      trackAnalyticsEvent('Tapped on Class Code',
      {'From': 'Onboarding', 'From Page': 'Homepage'}, true);
      location.href = '/student';
    }
  }

  render() {

    return (
      <div className={`parent-onboarding ela-signup-sections`}>
        <MainHeader LoginText={true}/>
        <div className="wrapper container">
          <div className="subject-head">
            <h2>How would you like to get started?</h2>
          </div>
          <ul className="account-mode">
            <li className="classmode-tile">
              <div onClick={()=>this.accountModeHandler(false)}>
                <div>
                  <img className="classmode-icon" src={assetPath(ClassMode)} alt=""/>
                </div>
                <p>Connect with Class Code</p>
              </div>
              <p>Set up SplashLearn using the class code or invite from a teacher</p>

            </li>
            <li className="homemode-tile">
              <div onClick={()=>this.accountModeHandler(true)}>
                <div>
                  <img className="homemode-icon" src={assetPath(ParentMode)} alt=""/>
                </div>
                <p>Setup for Personal Use</p>
              </div>
              <p>Set up SplashLearn for personal use</p>
            </li>
          </ul>
        </div>
      </div>
    )
  }
}

export default connect(null,null, SelectAccountMode);


